var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var yulifePink = {
    /**
     * @deprecated use primary100
     */
    P100: "#E30D76",
    /**
     * @deprecated use primary90
     */
    P90: "#F43E8E",
    /**
     * @deprecated use primary80
     */
    P50: "#F186BA",
    /**
     * @deprecated use primary70
     */
    P40: "#F49DC8",
    /**
     * @deprecated use primary60
     */
    P30: "#F7B7D6",
    /**
     * @deprecated use primary50
     */
    P20: "#F9CEE4",
    /**
     * @deprecated use primary40
     */
    P10: "#FCE7F1",
};
var uncommonGreen = {
    /**
     * @deprecated use green100
     */
    S1100: "#00ED9D",
    /**
     * @deprecated use green50
     */
    S150: "#80F6CD",
    /**
     * @deprecated use green40
     */
    S140: "#99F8D7",
    /**
     * @deprecated use green30
     */
    S130: "#B1F9E0",
    /**
     * @deprecated use green20
     */
    S120: "#CAF8E8",
    /**
     * @deprecated use green10
     */
    S110: "#E4FCF4",
};
var rareBlue = {
    /**
     * @deprecated use blue100
     */
    S2100: "#00C0F3",
    /**
     * @deprecated use blue50
     */
    S250: "#7EDCF5",
    /**
     * @deprecated use blue40
     */
    S240: "#94DDF1",
    /**
     * @deprecated use blue30
     */
    S230: "#B2ECFB",
    /**
     * @deprecated use blue20
     */
    S220: "#CAEFF9",
    /**
     * @deprecated use blue10
     */
    S210: "#E3F7FC",
};
var epicPurple = {
    /**
     * @deprecated use purple100
     */
    S3100: "#956AFF",
    /**
     * @deprecated use purple50
     */
    S350: "#C7B4FD",
    /**
     * @deprecated use purple40
     */
    S340: "#D2C2FD",
    /**
     * @deprecated use purple30
     */
    S330: "#DFD3FF",
    /**
     * @deprecated use purple20
     */
    S320: "#EAE1FF",
    /**
     * @deprecated use purple10
     */
    S310: "#F4F0FF",
};
var legendaryYellow = {
    /**
     * @deprecated use yellow100
     */
    S4100: "#FFD600",
    /**
     * @deprecated use yellow50
     */
    S450: "#FFEB80",
    /**
     * @deprecated use yellow40
     */
    S440: "#FFEF99",
    /**
     * @deprecated use yellow30
     */
    S430: "#FFF3B2",
    /**
     * @deprecated use yellow20
     */
    S420: "#FFF7CC",
    /**
     * @deprecated use yellow10
     */
    S410: "#FFFBE5",
};
var burgundy = {
    /**
     * @deprecated use inkHeadline
     */
    H100: "#640038",
};
var stone = {
    /**
     * @deprecated use inkBase
     */
    B1100: "#5C5757",
};
var pebble = {
    /**
     * @deprecated use inkSubtle
     */
    B2100: "#A0A09B",
    /**
     * @deprecated use inkNonEssential
     */
    B240: "#D9D9D7",
    /**
     * @deprecated use N30
     */
    B230: "#E3E3E1",
    /**
     * @deprecated use N20
     */
    B220: "#F5F5F5",
    B210: "#FAFAFE",
    B215: "#F2F2FA",
};
var newPink = {
    /**
     * @deprecated use primary70
     */
    newP70: "#F49DC8",
    /**
     * @deprecated use primary50
     */
    newP50: "#F9CEE4",
    /**
     * @deprecated use primary40
     */
    newP40: "#FCE7F1",
};
var neutralLegacy = {
    /**
     * @deprecated use neutral10
     */
    N10: "#FBFBFB",
    /**
     * @deprecated use neutral20
     */
    N20: "#F5F5F5",
    /**
     * @deprecated use neutral30
     */
    N30: "#E3E3E1",
    /**
     * @deprecated use neutral40
     */
    N40: "#D9D9D7",
    /**
     * @deprecated use neutral50
     */
    N50: "#A0A09B",
    N200: "#D3D3D6",
    N800: "#5A5A5C",
    /**
     * @deprecated use strong
     */
    N900: "#464647",
};
var statusLegacy = {
    /**
     * @deprecated use error10
     */
    ER100: "#FFF2F2",
    /**
     * @deprecated use error100
     */
    ER300: "#FF5F5F",
    ER400: "#FC0000",
    WA100: "#FAF4E6",
    /**
     * @deprecated use warning100
     */
    WA300: "#F19E22",
    WA400: "#FAB005",
    SU100: "#ECF9EE",
    /**
     * @deprecated use success100
     */
    SU300: "#66CC78",
    SU400: "#40C057",
    FO400: "#3871D0",
    /**
     * @deprecated use info10
     */
    IN100: "#E6EDF9",
    /**
     * @deprecated use info100
     */
    IN300: "#5A89D8",
};
export var legacy = __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({ yulifePink: yulifePink, uncommonGreen: uncommonGreen, rareBlue: rareBlue, epicPurple: epicPurple, legendaryYellow: legendaryYellow, burgundy: burgundy, stone: stone, pebble: pebble, legacy: neutralLegacy, status: statusLegacy }, yulifePink), uncommonGreen), rareBlue), epicPurple), legendaryYellow), burgundy), stone), pebble), newPink), neutralLegacy), statusLegacy);
